import { MediaType } from '../MediaType';
import type { ExperimentalMutations } from '../__types__/ExperimentalMutations';

export const experimentalAddCustomizedPersonalSpace: ExperimentalMutations['experimentalAddCustomizedPersonalSpace'] =
	(_, { spaceName }, { network: { cfetch } }) =>
		cfetch(
			`/wiki/rest/create-dialog/1.0/space-blueprint/create-custom-name-personal-space?favorite=true`,
			{
				method: 'POST',
				body: JSON.stringify({
					name: spaceName,
				}),
				headers: {
					'Content-Type': MediaType.JSON,
				},
			},
		).then(
			/* onFulfilled */ () => ({ result: true }),
			/* onRejected */ (e) => ({ result: false, error: e?.message }),
		);
